import { driver } from "driver.js";

function injectTourStyles() {
  const styleId = "vexis-driver-styles";
  if (document.getElementById(styleId)) return;
  const style = document.createElement("style");
  style.id = styleId;
  // Inline driver.js base CSS (driver.js/dist/driver.css) + Vexis dark theme overrides
  style.textContent = `.driver-active .driver-overlay,.driver-active *{pointer-events:none}.driver-active .driver-active-element,.driver-active .driver-active-element *,.driver-popover,.driver-popover *{pointer-events:auto}@keyframes animate-fade-in{0%{opacity:0}to{opacity:1}}.driver-fade .driver-overlay{animation:animate-fade-in .2s ease-in-out}.driver-fade .driver-popover{animation:animate-fade-in .2s}.driver-popover{all:unset;box-sizing:border-box;color:#2d2d2d;margin:0;padding:15px;border-radius:5px;min-width:250px;max-width:300px;box-shadow:0 1px 10px #0006;z-index:1000000000;position:fixed;top:0;right:0;background-color:#fff}.driver-popover *{font-family:Helvetica Neue,Inter,ui-sans-serif,"Apple Color Emoji",Helvetica,Arial,sans-serif}.driver-popover-title{font:19px/normal sans-serif;font-weight:700;display:block;position:relative;line-height:1.5;zoom:1;margin:0}.driver-popover-close-btn{all:unset;position:absolute;top:0;right:0;width:32px;height:28px;cursor:pointer;font-size:18px;font-weight:500;color:#d2d2d2;z-index:1;text-align:center;transition:color;transition-duration:.2s}.driver-popover-close-btn:hover,.driver-popover-close-btn:focus{color:#2d2d2d}.driver-popover-title[style*=block]+.driver-popover-description{margin-top:5px}.driver-popover-description{margin-bottom:0;font:14px/normal sans-serif;line-height:1.5;font-weight:400;zoom:1}.driver-popover-footer{margin-top:15px;text-align:right;zoom:1;display:flex;align-items:center;justify-content:space-between}.driver-popover-progress-text{font-size:13px;font-weight:400;color:#727272;zoom:1}.driver-popover-footer button{all:unset;display:inline-block;box-sizing:border-box;padding:3px 7px;text-decoration:none;text-shadow:1px 1px 0 #fff;background-color:#fff;color:#2d2d2d;font:12px/normal sans-serif;cursor:pointer;outline:0;zoom:1;line-height:1.3;border:1px solid #ccc;border-radius:3px}.driver-popover-footer .driver-popover-btn-disabled{opacity:.5;pointer-events:none}:not(body):has(>.driver-active-element){overflow:hidden!important}.driver-no-interaction,.driver-no-interaction *{pointer-events:none!important}.driver-popover-footer button:hover,.driver-popover-footer button:focus{background-color:#f7f7f7}.driver-popover-navigation-btns{display:flex;flex-grow:1;justify-content:flex-end}.driver-popover-navigation-btns button+button{margin-left:4px}.driver-popover-arrow{content:"";position:absolute;border:5px solid #fff}.driver-popover-arrow-side-over{display:none}.driver-popover-arrow-side-left{left:100%;border-right-color:transparent;border-bottom-color:transparent;border-top-color:transparent}.driver-popover-arrow-side-right{right:100%;border-left-color:transparent;border-bottom-color:transparent;border-top-color:transparent}.driver-popover-arrow-side-top{top:100%;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent}.driver-popover-arrow-side-bottom{bottom:100%;border-left-color:transparent;border-top-color:transparent;border-right-color:transparent}.driver-popover-arrow-side-center{display:none}.driver-popover-arrow-side-left.driver-popover-arrow-align-start,.driver-popover-arrow-side-right.driver-popover-arrow-align-start{top:15px}.driver-popover-arrow-side-top.driver-popover-arrow-align-start,.driver-popover-arrow-side-bottom.driver-popover-arrow-align-start{left:15px}.driver-popover-arrow-align-end.driver-popover-arrow-side-left,.driver-popover-arrow-align-end.driver-popover-arrow-side-right{bottom:15px}.driver-popover-arrow-side-top.driver-popover-arrow-align-end,.driver-popover-arrow-side-bottom.driver-popover-arrow-align-end{right:15px}.driver-popover-arrow-side-left.driver-popover-arrow-align-center,.driver-popover-arrow-side-right.driver-popover-arrow-align-center{top:50%;margin-top:-5px}.driver-popover-arrow-side-top.driver-popover-arrow-align-center,.driver-popover-arrow-side-bottom.driver-popover-arrow-align-center{left:50%;margin-left:-5px}.driver-popover-arrow-none{display:none}

    /* Vexis dark theme overrides */
    .driver-popover {
      background: #1e1e2e !important;
      color: #e2e8f0 !important;
      border: 1px solid rgba(99,102,241,0.3) !important;
      border-radius: 12px !important;
      box-shadow: 0 20px 60px rgba(0,0,0,0.6) !important;
    }
    .driver-popover-title {
      color: #ffffff !important;
      font-size: 16px !important;
      font-weight: 600 !important;
    }
    .driver-popover-description {
      color: #94a3b8 !important;
      font-size: 14px !important;
      line-height: 1.6 !important;
    }
    .driver-popover-footer button {
      background: #6366f1 !important;
      color: white !important;
      border: none !important;
      border-radius: 6px !important;
      padding: 6px 14px !important;
      cursor: pointer !important;
      font-size: 13px !important;
    }
    .driver-popover-footer button:hover {
      background: #5558e3 !important;
    }
    .driver-popover-footer .driver-popover-close-btn {
      background: transparent !important;
      color: #64748b !important;
      font-size: 18px !important;
      padding: 0 !important;
    }
    .driver-popover-footer .driver-popover-close-btn:hover {
      color: #94a3b8 !important;
      background: transparent !important;
    }
    .driver-popover-progress-text {
      color: #64748b !important;
      font-size: 12px !important;
    }
    .driver-overlay {
      background: rgba(0,0,0,0) !important;
    }
  `;
  document.head.appendChild(style);
}

export function startOnboardingTour(): void {
  injectTourStyles();

  const driverObj = driver({
    animate: true,
    smoothScroll: true,
    allowClose: true,
    overlayOpacity: 0.75,
    stagePadding: 10,
    stageRadius: 8,
    popoverClass: "vexis-tour-popover",
    doneBtnText: "Got it — let\u2019s go!",

    nextBtnText: "Next \u2192",
    prevBtnText: "\u2190 Back",
    onDestroyStarted: () => {
      markTourComplete();
      driverObj.destroy();
    },
    steps: [
      {
        element: "#tour-welcome",
        popover: {
          title: "\uD83D\uDC4B Welcome to Vexis",
          description: "This is your recruitment dashboard. Let\u2019s take 60 seconds to show you how it works.",
          side: "bottom",
          align: "start",
        },
      },
      {
        element: "#tour-invite-candidate",
        popover: {
          title: "Step 1 \u2014 Invite a Candidate",
          description: "Start here. Enter a candidate\u2019s details and send them a video assessment link. They complete it in under 15 minutes on any device \u2014 no app needed.",
          side: "bottom",
          align: "start",
        },
      },
      {
        element: "#tour-pipeline",
        popover: {
          title: "Step 2 \u2014 Track Your Pipeline",
          description: "Every candidate moves through your pipeline automatically. AI scores their responses and moves them to the right stage. You review and decide.",
          side: "right",
          align: "start",
        },
      },
      {
        element: "#tour-dossier",
        popover: {
          title: "Step 3 \u2014 Review the Dossier",
          description: "Once AI scoring is complete, a boardroom-ready candidate dossier is generated automatically. Share it with your client in one click.",
          side: "left",
          align: "start",
        },
      },
      {
        element: "#tour-settings",
        popover: {
          title: "Step 4 \u2014 Configure Your Settings",
          description: "Connect your ATS, set up your sending email and SMS, and customise your assessment templates here.",
          side: "right",
          align: "start",
        },
      },
      {
        element: "#tour-help",
        popover: {
          title: "You\u2019re ready to go \uD83D\uDE80",
          description: "Click this button any time to replay this tour. If you need help, contact us at support@vexistalentagency.com",
          side: "left",
          align: "end",
        },
      },
    ],
  });

  driverObj.drive();
}

export function markTourComplete(): void {
  localStorage.setItem("vexis_tour_complete", "true");
}

export function hasTourBeenCompleted(): boolean {
  return localStorage.getItem("vexis_tour_complete") === "true";
}

export function resetTour(): void {
  localStorage.removeItem("vexis_tour_complete");
}
